module.exports = __webpack_public_path__ + "static/media/navigation-tabletWithLogoVW2.ce6a4a24.png";